import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { VoipHoliday } from '../_types/voip-holiday';

@Injectable({
  providedIn: 'root'
})
export class VoipHolidaysService extends Service<VoipHoliday> {
  public override type = 'voipHolidays';
  public override url = 'communications/voipHolidays';
}